import React from 'react';
import { useRecoilValue } from 'recoil';
import type { CombinePortfoliosOrganizeOptionEnum } from 'venn-api';
import { aggregatedGroupingState, openAllocatorSubject, originalAnalysisSubjectQuery } from 'venn-state';
import type { DropMenuItem } from 'venn-ui-kit';
import { DropMenu } from 'venn-ui-kit';
import { useHasFF, withSuspense } from 'venn-utils';
import { useSetAggregatedGrouping } from './useSetAggregatedGrouping';

const GROUP_BY_OPTIONS: DropMenuItem<CombinePortfoliosOrganizeOptionEnum>[] = [
  { label: 'Constituent portfolios', value: 'PORTFOLIO' },
  { label: 'Asset class', value: 'ASSET_CLASS' },
];

const AggregatedGroupBySelectorInner = () => {
  const hasGroupByFF = useHasFF('rcm_portfolio_maintenance_ff');
  const subject = useRecoilValue(openAllocatorSubject);
  const resolved = useRecoilValue(originalAnalysisSubjectQuery(subject));
  const portfolioId = subject?.type === 'portfolio' ? subject.portfolioId : undefined;
  const override = useRecoilValue(aggregatedGroupingState(portfolioId ?? NaN));
  const setAggregatedGrouping = useSetAggregatedGrouping();

  if (!hasGroupByFF || !resolved?.isAggregatedPortfolio || portfolioId === undefined) {
    return null;
  }

  const selected =
    override ?? resolved.portfolio?.aggregatedPortfolioSettings?.combineSettings?.organizeOption ?? 'PORTFOLIO';

  return (
    <div className="flex items-center gap-[8px] mt-[8px] pr-[36px]">
      <span className="shrink-0 text-[14px] font-bold">Group by</span>
      <div className="w-full [&_.qa-dropmenu-input-content]:font-normal">
        <DropMenu<CombinePortfoliosOrganizeOptionEnum>
          items={GROUP_BY_OPTIONS}
          selected={selected}
          onChange={({ value }) => setAggregatedGrouping(portfolioId, value)}
        />
      </div>
    </div>
  );
};

export const AggregatedGroupBySelector = withSuspense(null, AggregatedGroupBySelectorInner);
